// extracted by mini-css-extract-plugin
export default {"banner_wrapper":"InfoBanner_banner_wrapper__hcLgW","banner_tag":"InfoBanner_banner_tag__4yxDc"};